import {
  DppTriageProto_CompletionStatus,
  DppTriageSurveyTypeProto_Value,
} from "@noom/noom-contracts/noom_contracts/healthcare/dpp_triage";
import { Api } from "@noom/noomscape";

import axios, { AxiosResponse } from "axios";

export type DppTriageSurveyType = Extract<
  DppTriageSurveyTypeProto_Value,
  "INITIAL" | "RETRIAGE"
>;

type DppTriageRequest = {
  completionStatus: DppTriageProto_CompletionStatus;
  eligibilityId?: string | undefined;
  partnerId?: number | undefined;
  participantId?: string | undefined;
  resourceKey?: string | undefined;
  survey: Record<string, any>;
  surveyType: DppTriageSurveyType;
};

type DppTriageResponse = {
  key: string;
};

Api.register(
  "dpp.saveTriageData",
  async ({
    completionStatus,
    eligibilityId,
    participantId,
    partnerId,
    resourceKey,
    survey,
    surveyType,
  }: DppTriageRequest) => {
    const response: AxiosResponse<DppTriageResponse> = await axios({
      baseURL: window.ENV.SERVER_URL,
      data: {
        completionStatus,
        eligibilityId,
        participantId,
        partnerId,
        resourceKey,
        survey,
        surveyType,
      },
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      url: "/dpp/v1/triage",
      urlWithPathParams: "/dpp/v1/triage",
    });

    return response.data;
  },
);
